import { HistoricalEvent, historicalEventTypeMap } from "@customTypes/responses/lawsuit";
import React from "react";
import {
  BulletPointSpan,
  EventItemContainer,
  EventItemDescription,
  EventTitleContainer,
} from "../style";
import { formatStringDate } from "@helpers/dateHelpers";
import { NormalText } from "@components/styles/dataDisplay";
import EventIcon from "./EventIcon";
import Modal from "@components/Modal/Modal";
import { CustomHeading } from "@pages/style";
import { Button } from "nectar-ui";
import { hiddenTitlesByType } from "./historicalConstants";
import sanitizeHtml from "sanitize-html";

type EventItemProps = {
  event: HistoricalEvent;
  withLine?: boolean;
  single?: boolean;
};

const writeTitle = (event: HistoricalEvent) => {
  switch (event.type) {
    case "DONE_TASK":
      return `Tarefa concluída por ${event.responsibleName}`;
    case "MANUALLY":
      return `${event.responsibleName} registrou`;
    case "AUTOMATIC_LAWSUIT":
      return `Andamento automático`;
    case "CLIPPING":
      return "Publicação";
    default:
      return `Andamento automático`;
  }
};

const EventItem: React.FC<EventItemProps> = ({ event, withLine = false, single = false }) => {
  const [isModalOpen, setModalOpen] = React.useState(false);

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const WriteDescription = ({ eventDescription }: { eventDescription: string }) => {
    const sanitizedDescription = sanitizeHtml(eventDescription);

    if (eventDescription.length > 130)
      return (
        <div style={{ display: "flex", columnGap: 4, flexWrap: "wrap", alignItems: "flex-end" }}>
          <NormalText
            dangerouslySetInnerHTML={{
              __html: sanitizedDescription.substring(0, 127).concat("..."),
            }}
          ></NormalText>
          <Button link onClick={openModal}>
            Ver mais
          </Button>
        </div>
      );

    return <NormalText>{event.description}</NormalText>;
  };

  return (
    <EventItemContainer
      withLine={withLine}
      style={{ display: "flex", flexDirection: "column" }}
      single={single}
    >
      <EventTitleContainer single={single}>
        <div style={{ display: "flex", columnGap: 8, alignItems: "center" }}>
          <EventIcon eventType={event.type} />
          <NormalText semiBold noMargin>
            {writeTitle(event)}
          </NormalText>
        </div>
        {event.date && (
          <>
            <BulletPointSpan>•</BulletPointSpan>
            <NormalText noMargin color="gray">
              {formatStringDate(event.date)}
            </NormalText>
          </>
        )}
      </EventTitleContainer>
      <EventItemDescription noMargin>
        <WriteDescription eventDescription={event.description} />
      </EventItemDescription>
      <Modal onClose={closeModal} blackout isOpen={isModalOpen}>
        <CustomHeading semiBold>{historicalEventTypeMap[event.type]}</CustomHeading>
        {event.date && (
          <div style={{ display: "flex", columnGap: 8 }}>
            <NormalText noMargin semiBold>
              Data:
            </NormalText>
            <NormalText noMargin color="gray">
              {formatStringDate(event.date)}
            </NormalText>
          </div>
        )}
        <div style={{ display: "flex", flexDirection: "column", rowGap: 8 }}>
          {!hiddenTitlesByType.includes(event.type) && (
            <NormalText size="xs" semiBold>
              {writeTitle(event)}:
            </NormalText>
          )}
          <NormalText
            noMargin
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(event.description),
            }}
          >
            {event.description}
          </NormalText>
        </div>
      </Modal>
    </EventItemContainer>
  );
};

export default EventItem;
